import styled from 'styled-components';

export const FullHeightContainer = styled.div`
  min-height: 100vh;
`;
